/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'news-feed-pinned': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M19.536 1.15l11.313 11.314-3.535 2.122-1.415-1.414-7.07 7.07c.942 2.83.235 5.422-2.122 7.779L3.98 15.293c2.357-2.357 4.95-3.064 7.778-2.121L18.828 6.1l-1.414-1.415 2.122-3.535z"/><path pid="1" _fill="currentColor" _stroke="none" d="M9.282 20.596l2.122 2.122-9.193 7.778-.707-.707z"/><path pid="2" d="M25.9 13.172L18.827 6.1"/></g>'
  }
})
